<cw-ci-data-table #notificationDataTable
  tileTitle="Notifications"
  addToolTip="Create a new notification"
  refreshToolTip="Reload notification list"
  defaultSortField="created_at"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadNotifications($event)"
  (addHandler)="addNotification($event)"
  (selectHandler)="editNotification($event)"
  [items]="notificationList">

  <cw-ci-table-column columnName="id" columnTitle="Id" sortField="id"></cw-ci-table-column>
  <cw-ci-table-column columnName="subject" columnTitle="Subject" sortField="subject" searchField="subject" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="type" columnTitle="Type" sortField="type" filterType="select" [filterOptions]="[{display:'Informational', value:'INFORMATIONAL'}, {display:'Marketing', value:'MARKETING'}, {display:'System Alert', value:'SYSTEM_ALERT'}, {display:'New Assessment', value:'NEW_ASSESSMENT'}, {display:'Completed Assessment', value:'COMPLETED_ASSESSMENT'}]"></cw-ci-table-column>

  <cw-ci-table-column columnName="referenceIds" columnTitle="Reference Ids"></cw-ci-table-column>

  <cw-ci-table-column columnName="createdAt" columnTitle="Created" sortField="created_at" [output]="createdAtTemplate"></cw-ci-table-column>
  <ng-template let-element #createdAtTemplate>{{element.createdAt | date:'mediumDate':'+0000'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the notification" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editNotification($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>
